import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  SortingState,
} from '@tanstack/react-table';
import { useMemo, useState } from 'react';

import { Resource } from 'features/resourceBank/types';
import { resourceBankTableColumnsData } from 'features/resourceBank/utils/tableData';

const defaultSorting: SortingState = [
  {
    id: 'createdAt',
    desc: true,
  },
];

export const useResourceTableData = (resources: Resource[]) => {
  const columns = useMemo(() => resourceBankTableColumnsData, []);
  const [sorting, setSorting] = useState<SortingState>(defaultSorting);

  return useReactTable({
    columns,
    data: resources,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });
};
